import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useSelector } from 'react-redux';
import { RootState } from '~/store/types/sharedTypes';
export const useMaintenanceFeatureFlagEnabled = () => {
  const { market } = useSelector((state: RootState) => state.intl);
  const maintenanceFlagName = `maintenance-mode-${market.toLowerCase()}`;
  return useFeatureFlagEnabled(maintenanceFlagName);
};
